import React from "react";

import style from "./SetupCredentialsPage.module.scss";

export const SetupCredentialsPage = () => {
  return (
    <div className={style.container}>
      <h1 className={style.loginTitle}>eAkcize</h1>
      <p className={style.text}>Uspešno ste podesili kredencijale!</p>
    </div>
  );
};
